import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { CUSTOM_ORDER_PATHS } from '../../constants';
import { EncodeHelper } from '../../helpers/encode.helper';
import {
  DowloadReportsRequestDTO,
  GeneralReportDTO,
  GetReportsByShipperResponse,
  GetReportsByUserResponse,
  ReportsByShipperRequestDTO,
  ReportsByUserRequestDTO,
  SuccessDTO,
} from '../../interfaces/models';
import { PathService } from '../path/path.service';
import { ReportsUiService } from './reports.ui.service';

@Injectable()
export class ReportsService {

  constructor(
      private http: HttpClient,
      private readonly reportsUiService: ReportsUiService,
      private readonly pathService: PathService,
    ) { }

  private encodeData(data) {
    return Object.keys(data)
      .filter(key => data[key])
      .map((key) => {
        return [key, data[key]].map(encodeURIComponent).join('=');
      })
      .join('&');
  }

  public getGeneral(): Observable<GeneralReportDTO> {
    return this.http.get<GeneralReportDTO>(this.pathService.getReportPathByRole('/reports/general')).pipe(
      map(response => this.reportsUiService.getFormattedReports(response)),
    );
  }

  public getRevenue(filter?: ReportsByShipperRequestDTO): Observable<GetReportsByShipperResponse> {
    const filterPath = this.encodeData(filter);
    return this.http.get<GetReportsByShipperResponse>(`${environment.api}/company/me/reports/shipper?${filterPath}`);
  }

  public getReportsByUser(filter?: ReportsByUserRequestDTO): Observable<GetReportsByUserResponse> {
    const filterPath = EncodeHelper.encodeData(filter);
    const path = this.pathService.getReportPathByRole(`/reports/user?${filterPath}`);
    return this.http.get<GetReportsByUserResponse>(path);
  }

  public dowloadReportsByUser(body: DowloadReportsRequestDTO): Observable<SuccessDTO> {
    const path = this.pathService.getReportPathByRole(`/reports/user`);
    return this.http.post<SuccessDTO>(path, body);
  }

  public dowloadReports(filter: ReportsByUserRequestDTO): Observable<Blob> {
    const path = this.pathService.getReportPathByRole(`/reports/user/download`);
    return this.http.post(path, { filter }, {
      responseType: 'blob',
    });
  }

  public getCustomOrderPaths() {
    const path = this.pathService.getCustomReportPathByRole(CUSTOM_ORDER_PATHS.REPORTED);
    return path;
  }
}
